import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Product_Interface, Product_Interface } from 'src/app/Interface/Product_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProductService } from 'src/app/Service/Product/Product.service';
import { ProductGroupService } from 'src/app/Service/ProductGroup/ProductGroup.service';

@Component({
  selector: 'app-ProductAdd',
  templateUrl: './ProductAdd.component.html',
  styleUrls: ['./ProductAdd.component.css']
})
export class ProductAddComponent implements OnInit {

  constructor(
    private Product_Service: ProductService,
    private ProductGroup_Service: ProductGroupService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    this.AddNewProduct = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
    })


    this.Nav_Service.CheckValidPage(2207).subscribe(
      data => {
        this.ReadData_ProductGroup()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }



  //#region  Group

  modalRef_ProductGroup: any;
  page: number = 0

  ProcssingProductGroup: boolean = false

  Search_Name_ProductGroup_Table: string = ''

  openModal_ProductGroup(template: TemplateRef<any>) {
    this.modalRef_ProductGroup = this.modalService.show(template);
  }

  DataList_ProductGroup: Array<General_Interface> = []
  Data_Seleted_Record: General_Interface = Empty_General_Interface()



  ReadData_ProductGroup() {
    this.ProcssingProductGroup = true
    this.ProductGroup_Service.GetActiveList().subscribe(
      data => {
        this.DataList_ProductGroup = data
        this.ProcssingProductGroup = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Set_Selected_ProductGroup_Record(item) {
    this.Data_Seleted_Record = item
    this.modalRef_ProductGroup.hide()
  }

  //#endregion



  //#region  Form Add

  AddNewProduct: FormGroup;

  get_Form_Title() {
    return this.AddNewProduct.get('Title') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitAddNewProduct() {

    if (this.Data_Seleted_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("گروه کالا را انتخاب نمائید")
    }
    else {
      var Record: Product_Interface = Empty_Product_Interface()
      Record.id = 0
      Record.title = this.get_Form_Title().value
      Record.product_group_id = this.Data_Seleted_Record.id
      Record.group_title = this.Data_Seleted_Record.title + ''
      Record.title = this.get_Form_Title().value
      this.InProccessing = true
      this.Product_Service.AddProduct(Record).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else {
            this.AddNewProduct.reset()
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }


}
